import { Record, Map as ImmutableMap } from 'immutable';
import getIn from 'immutable-less/transmute/getIn';
import ExecutionResultKeys from 'automation-ui-log-events/records/ExecutionResult/ExecutionResultKeys';
import ContextMapKeys from 'automation-ui-log-events/records/ExecutionResult/ContextMapKeys';
export default class ExecutionResult extends Record({
  [ExecutionResultKeys.ASSOCIATED_EXECUTION_STATE]: null,
  [ExecutionResultKeys.ERROR_TYPE]: null,
  [ExecutionResultKeys.ERROR_SUB_TYPE]: null,
  [ExecutionResultKeys.ENTITY_ID]: null,
  [ExecutionResultKeys.ENTITY_TYPE]: null,
  [ExecutionResultKeys.CONTEXT_MAP]: ImmutableMap()
}, 'ExecutionResult') {
  constructor(props) {
    let propMap = ImmutableMap(props);
    const contextMap = propMap.get(ExecutionResultKeys.CONTEXT_MAP);
    propMap = propMap.set(ExecutionResultKeys.CONTEXT_MAP, ImmutableMap(contextMap || {}));
    super(propMap);

    /*
     * Anything stored in apollos cache is deeply frozen.
     * Call hashCode to set the cache property before we load it into
     * data-fetching-client's cache so it doesn't try to write and throw
     * an exception
     */
    this.hashCode();
  }
  getAssociatedExecutionState() {
    return getIn([ExecutionResultKeys.ASSOCIATED_EXECUTION_STATE], this);
  }
  getErrorType() {
    return getIn([ExecutionResultKeys.ERROR_TYPE], this);
  }
  getErrorSubType() {
    return getIn([ExecutionResultKeys.ERROR_SUB_TYPE], this);
  }
  getEntityId() {
    return getIn([ExecutionResultKeys.ENTITY_ID], this);
  }
  getEntityType() {
    return getIn([ExecutionResultKeys.ENTITY_TYPE], this);
  }
  getContextMap() {
    return getIn([ExecutionResultKeys.CONTEXT_MAP], this);
  }
  getFullEmailAddress() {
    return getIn([ExecutionResultKeys.CONTEXT_MAP, ContextMapKeys.FULL_EMAIL_ADDRESS], this);
  }
  getObjectTypeId() {
    return getIn([ExecutionResultKeys.CONTEXT_MAP, ContextMapKeys.OBJECT_TYPE_ID], this);
  }
}